"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ring = void 0;
var _pixi = require("pixi.js");
var _Particles = require("./Particles");
var _Light = require("./Light");
var _color = _interopRequireDefault(require("color"));
var _core = require("@dragon/core");
var _operators = require("rxjs/operators");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function random(min, max) {
  return Math.random() * (max - min) + min;
}
var Ring = exports.Ring = /*#__PURE__*/function (_Container) {
  function Ring() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? "€" : _ref$currency,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$frameSpeed = _ref.frameSpeed,
      frameSpeed = _ref$frameSpeed === void 0 ? 5 : _ref$frameSpeed,
      _ref$rotation = _ref.rotation,
      rotation = _ref$rotation === void 0 ? 0.01 : _ref$rotation,
      _ref$numberLightSide = _ref.numberLightSide,
      numberLightSide = _ref$numberLightSide === void 0 ? 20 : _ref$numberLightSide,
      _ref$numberLightCircl = _ref.numberLightCircle,
      numberLightCircle = _ref$numberLightCircl === void 0 ? 180 : _ref$numberLightCircl,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? [0x686bec, 0x4451f6, 0x5e69f7] : _ref$colors,
      _ref$displacement = _ref.displacement,
      displacement = _ref$displacement === void 0 ? 60 : _ref$displacement,
      _ref$blur = _ref.blur,
      blur = _ref$blur === void 0 ? 0 : _ref$blur,
      _ref$textStyle = _ref.textStyle,
      textStyle = _ref$textStyle === void 0 ? {
        fill: ["aliceblue", "lightsteelblue"],
        fontFamily: ["Montserrat", "Helvetica", "Arial", "sans-serif"],
        fontSize: 74,
        letterSpacing: 5,
        stroke: "lightsteelblue",
        dropShadow: true,
        dropShadowAlpha: 0.2,
        strokeThickness: 5
      } : _ref$textStyle;
    var renderer = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, Ring);
    _this = _callSuper(this, Ring);
    _defineProperty(_this, "currency", void 0);
    _defineProperty(_this, "number", void 0);
    _defineProperty(_this, "spawnFrame", void 0);
    _defineProperty(_this, "frameSpeed", void 0);
    _defineProperty(_this, "frame", void 0);
    _defineProperty(_this, "time", void 0);
    _defineProperty(_this, "divisor", void 0);
    _defineProperty(_this, "w", void 0);
    _defineProperty(_this, "h", void 0);
    _defineProperty(_this, "back", void 0);
    _defineProperty(_this, "front", void 0);
    _defineProperty(_this, "aura", void 0);
    _defineProperty(_this, "bg", void 0);
    _defineProperty(_this, "colorBg", void 0);
    _defineProperty(_this, "renderTexture", void 0);
    _defineProperty(_this, "backSprite", void 0);
    _defineProperty(_this, "particles", void 0);
    _defineProperty(_this, "fakeBloom", void 0);
    _defineProperty(_this, "map", void 0);
    _defineProperty(_this, "displacement", void 0);
    _defineProperty(_this, "containers", void 0);
    _defineProperty(_this, "sprites", void 0);
    _defineProperty(_this, "sprites2", void 0);
    _defineProperty(_this, "text", void 0);
    _defineProperty(_this, "textStyle", void 0);
    _defineProperty(_this, "channel", void 0);
    _this.textStyle = textStyle;
    _this.currency = currency;
    _this.number = number;
    _this.rotation = rotation;
    _this.spawnFrame = 40;
    _this.frameSpeed = frameSpeed;
    _this.frame = 0;
    _this.time = 0;
    _this.renderer = renderer;
    _this.divisor = 1;
    _this.w = 512;
    _this.h = 512;
    _this.back = new _pixi.Container();
    _this.front = new _pixi.Container();
    _this.channel = _core.CORE.getState().config.channel;
    var backgroundBack = new _pixi.Graphics();
    backgroundBack.beginFill(0x000000);
    backgroundBack.drawRect(0, 0, _this.w, _this.h);
    _this.back.addChild(backgroundBack);
    _this.aura = new _pixi.Sprite(_pixi.Texture.from("aura.png"));
    _this.aura.tint = 0x686bec;
    _this.aura.tintHsl = (0, _color["default"])(0x686bec).hsl().object();
    _this.aura.scale.set(2.6);
    _this.aura.anchor.set(0.5);
    _this.aura.position.x = _this.w / 2;
    _this.aura.position.y = _this.h / 2;
    _this.back.addChild(_this.aura);
    _this.bg = new _pixi.Sprite(_pixi.Texture.from("background.png"));
    _this.bg.tint = 0x686bec;
    _this.bg.scale.set(2.6);
    _this.bg.anchor.set(0.5);
    _this.bg.position.x = _this.w / 2;
    _this.bg.position.y = _this.h / 2;
    _this.back.addChild(_this.bg);
    var colorBlur = new _pixi.filters.BlurFilter(20);
    _this.colorBg = new _pixi.Graphics();
    _this.colorBg.beginFill(0x170a81, 0.6);
    // this.colorBg.fillAlpha = 0.6 ///chek wijhat
    _this.colorBg.filters = [colorBlur];
    _this.colorBg.drawCircle(0, 0, _this.w / 2.8);
    _this.addChild(_this.colorBg);
    _this.renderTexture = _pixi.RenderTexture.create({
      width: _this.w,
      height: _this.h,
      scaleMode: _pixi.SCALE_MODES.LINEAR,
      resolution: 1
    });
    _this.backSprite = new _pixi.Sprite(_this.renderTexture);
    _this.backSprite.anchor.set(0.5);
    _this.backSprite.blendMode = _pixi.BLEND_MODES.SCREEN;
    _this.addChild(_this.backSprite);
    _this.particles = new _Particles.Particles();
    _this.addChild(_this.particles);
    _this.addChild(_this.front);
    _this.addText(textStyle);
    _this.addContainers();
    _this.addSprites(numberLightSide, numberLightCircle, colors);
    _this.addFilters(displacement); //, blur)

    _this.setPrice(number);
    _this.fakeBloom = new _pixi.Sprite(_pixi.Texture.from("bloom.png"));
    // reduces the "whiteness behind the text."
    _this.fakeBloom.alpha = 0.3;
    _this.fakeBloom.blendMode = _pixi.BLEND_MODES.ADD;
    _this.fakeBloom.scale.set(2);
    _this.fakeBloom.anchor.set(0.5);
    _this.fakeBloom.position.x = _this.w / 2;
    _this.fakeBloom.position.y = _this.h / 2;
    _this.back.addChild(_this.fakeBloom);
    return _this;
  }
  _inherits(Ring, _Container);
  return _createClass(Ring, [{
    key: "addFilters",
    value: function addFilters(displacement) {
      var map = new _pixi.Sprite(_pixi.Texture.from("displacement_map.png"));
      map.scale.set(2);
      this.back.addChild(map);
      map.anchor.set(0.5);
      map.x = this.w / 2;
      map.y = this.h / 2;
      this.map = map;
      this.displacement = new _pixi.filters.DisplacementFilter(map);
      this.displacement.scale.x = displacement;
      this.displacement.scale.y = displacement;
      this.back.filters = [this.displacement];
    }
  }, {
    key: "addContainers",
    value: function addContainers() {
      this.containers = [];
      for (var i = 0; i < 8; i++) {
        var container = new _pixi.Container();
        var containerCenter = new _pixi.Container();
        containerCenter.position.x = -this.w / 2;
        containerCenter.position.y = -this.h / 2;
        container.position.x = this.w / 2;
        container.position.y = this.h / 2;
        container.addChild(containerCenter);
        this.containers.push({
          container: container,
          center: containerCenter,
          r: random(-1, 1)
        });
        this.back.addChild(container);
      }
    }
  }, {
    key: "addSprites",
    value: function addSprites(numberLightSide, numberLightCircle, colors) {
      this.sprites = [];
      for (var i = 0; i < numberLightSide; i++) {
        var sprite = new _Light.Light({
          x: 0,
          y: 0.5
        }, 40, colors, 0.2, [160, 170], [45, 90], true);
        sprite.resize(this.w, this.h);
        sprite.init();
        this.back.addChild(sprite.view);
        this.sprites.push(sprite);
      }
      this.sprites2 = [];
      for (var _i = 0; _i < numberLightCircle; _i++) {
        var _sprite = new _Light.Light({
          x: 0.5,
          y: 0.5
        }, 40, colors, 0.4, [160, 200], [-90, 90], false);
        _sprite.resize(this.w, this.h);
        _sprite.init();
        this.sprites2.push(_sprite);
        var container = this.containers[Math.floor(Math.random() * this.containers.length)].center;
        container.addChild(_sprite.view);
      }
    }
  }, {
    key: "addText",
    value: function addText(style) {
      var text = new _pixi.BitmapText("", {
        fontName: "blitzbluebm",
        fontSize: 136,
        letterSpacing: -8,
        align: "left"
      });
      text.anchor.set(0.5, 0.5);
      text.y = -24;
      text["originalScale"] = 1;
      this.text = text;
      this.front.addChild(text);
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      _superPropGet(Ring, "updateTransform", this, 3)([]);
      this.time += 0.1;
      this.frame++;
      for (var i = 0; i < this.sprites.length; i++) {
        var sprite = this.sprites[i];
        sprite.count++;
        if (this.frame % Math.floor(this.frameSpeed) === 0) {
          sprite.view.texture = _pixi.Texture.from("lightning_0".concat(Math.floor(Math.random() * 7 + 1), ".png"));
        }
        if (sprite.count > this.spawnFrame) {
          sprite.reset();
        }
      }
      for (var _i2 = 0; _i2 < this.sprites2.length; _i2++) {
        var _sprite2 = this.sprites2[_i2];
        _sprite2.count++;
        if (this.frame % Math.floor(this.frameSpeed) === 0) {
          _sprite2.view.texture = _pixi.Texture.from("lightning_0".concat(Math.floor(Math.random() * 7 + 1), ".png"));
        }
        if (_sprite2.count > this.spawnFrame) {
          _sprite2.reset();
        }
      }
      for (var _i3 = 0; _i3 < this.containers.length; _i3++) {
        this.containers[_i3].container.rotation += this.rotation * this.containers[_i3].r;
      }
      this.map.rotation += 0.02;
      this.renderer.render(this.back, {
        renderTexture: this.renderTexture
      });
      this.aura.scale.x = 2.6 + Math.cos(this.time) * 0.1;
      this.aura.scale.y = 2.6 + Math.sin(this.time / 2) * 0.1;
      this.bg.scale.x = 2.3 + Math.cos(this.time / 1.5) * 0.2;
      this.bg.scale.y = 2.3 + Math.sin(this.time / 2) * 0.2;
      this.fakeBloom.scale.x = 1.8 + Math.cos(this.time / 1.5) * 0.2;
      this.fakeBloom.scale.y = 1.8 + Math.sin(this.time / 1.5) * 0.2;
      this.fakeBloom.rotation += 0.001;
    }
  }, {
    key: "setCurrency",
    value: function setCurrency(currency) {
      this.currency = currency;
    }
  }, {
    key: "setText",
    value: function setText(text) {
      this.text.text = text;
    }
  }, {
    key: "flyText",
    value: function flyText(text) {
      var ft = new _pixi.BitmapText(text, {
        fontName: "blitzgoldbm",
        fontSize: 86,
        letterSpacing: -30,
        align: "left"
      });
      ft.anchor.set(0.5, 0.5);
      ft.y = -40;
      ft.alpha = 0;
      this.front.addChildAt(ft, 0);
      (0, _core.createTween)(_core.easeOutSine, 1, 0, 1000, null).subscribe(function (f) {
        ft.alpha = f;
      });
      ft.x = ft.x + Math.floor(Math.random() * 200 + 1) - 100;
      (0, _core.createTween)(_core.easeOutSine, ft.x, ft.x + Math.floor(Math.random() * 400 + 1) - 150, 2000, null).subscribe(function (f) {
        ft.x = f;
      });
      (0, _core.createTween)(_core.easeOutSine, ft.y, ft.y - 300, 2000, null).pipe((0, _operators.finalize)(function () {
        ft.destroy();
      })).subscribe(function (f) {
        ft.y = f;
      });
    }
  }, {
    key: "setPrice",
    value: function setPrice(number) {
      if (number === null) return;
      var string = (0, _core.currencyFormatter)(number, _core.CORE.getState().balance.currency);
      if (this.channel == _core.Channel.Mobile) {
        if (string.length >= 6) {
          this.text["originalScale"] = 0.8;
          if (string.length >= 8) {
            this.text["originalScale"] = 0.7;
            if (string.length >= 9) {
              this.text["originalScale"] = 0.65;
            }
          }
        }
      }
      this.text.text = string;
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=Ring.js.map